module.exports = __webpack_public_path__ + "img/SKMA_rules2.0c19c32b.png";